import styled from 'styled-components'
import { getCheckmark } from 'icons'

export default styled.input.attrs({ type: 'checkbox' })`
  flex: none;

  width: 14px;
  height: 14px;
  margin: 0;

  background-color: white;
  background-repeat: no-repeat;
  background-position: center;
  border: 1px solid var(--gray);
  border-radius: 2px;

  cursor: pointer;
  appearance: none;
  transition: background-color 0.2s;

  :checked {
    background-image: url(${getCheckmark()});
  }

  :hover {
    background-color: var(--green_0-1);
  }

  :focus-visible {
    outline: 2px solid var(--green_0-5);
  }
`

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  font: var(--400-12);
  cursor: pointer;

  span:last-of-type:not(:only-of-type) {
    color: var(--red);
    font: var(--400-11);

    :empty {
      display: none;
    }
  }
`
